import { useTrans } from '../../../../services/i18n'
import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import connect from '../../connect'
import {
  MODULE_LABELS,
  MODULE_ROW_BOTTOM,
  MODULE_ROW_TOP,
  getLeftoverModules,
  getTabOptionsList,
  indexModulesByKey,
  mapSubscriptionTabOptions,
  pickModulesByKeys,
  toggleModuleInOptions,
  toggleSubmoduleInOptions,
} from './subscriptionSettingsHelpers'
import { renderModuleRow } from './renderModuleColumn'

const useStyles = makeStyles((theme) => ({
  moduleRow: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  moduleItem: {
    display: 'flex',
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: '100%',
    maxWidth: '100%',
    [theme.breakpoints.up('sm')]: {
      flexBasis: '50%',
      maxWidth: '50%',
    },
    [theme.breakpoints.up('md')]: {
      flexBasis: '33.3333%',
      maxWidth: '33.3333%',
    },
  },
  moduleItemInner: {
    alignContent: 'flex-start',
    width: '100%',
  },
  moduleHeaderRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: 12,
  },
  moduleHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    flex: 1,
  },
  moduleTitle: {
    fontSize: '15px',
    fontFamily: 'Lexend',
    fontWeight: 600,
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  switchWrap: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
  },
}))

const ManageFeatures = ({
  newUser = true,
  optionTab,
  updateSubscriptionSettings,
  subscriptionSettings,
}) => {
  const classes = useStyles()
  const { trans } = useTrans()
  const [modules, setModules] = useState([])

  const modulesByKey = useMemo(() => indexModulesByKey(modules), [modules])
  const topRowModules = useMemo(
    () => pickModulesByKeys(modulesByKey, MODULE_ROW_TOP),
    [modulesByKey]
  )
  const bottomRowModules = useMemo(
    () => pickModulesByKeys(modulesByKey, MODULE_ROW_BOTTOM),
    [modulesByKey]
  )
  const leftoverModules = useMemo(() => getLeftoverModules(modules), [modules])

  useEffect(() => {
    setModules(getTabOptionsList(subscriptionSettings, optionTab))
  }, [subscriptionSettings, optionTab])

  const changeColumn = (ev, mo) => {
    const checked = ev.target.checked
    const getOptionLists = (tab) =>
      newUser ? tab.newUsers.optionsList : tab.existingUsers.optionsList

    const newData = mapSubscriptionTabOptions(
      subscriptionSettings,
      optionTab,
      getOptionLists,
      (optionLists) => toggleModuleInOptions(optionLists, mo.key, checked)
    )

    updateSubscriptionSettings(newData)
  }

  const changeCheckbox = (ev, mo, checksOptions, vCheck) => {
    const isChecked = ev.target.checked
    const getOptionLists = (tab) => tab.existingUsers.optionsList

    const newData = mapSubscriptionTabOptions(
      subscriptionSettings,
      optionTab,
      getOptionLists,
      (optionLists) =>
        toggleSubmoduleInOptions(optionLists, mo.key, checksOptions.key, isChecked, vCheck)
    )

    updateSubscriptionSettings(newData)
  }

  const getLabel = (column) => MODULE_LABELS[column.key] || trans(column.key)

  return (
    <div key={`tab-main-grid-checks-title-${optionTab}-${newUser ? 'new-users' : 'existing-users'}`}>
      {renderModuleRow({
        rowModules: topRowModules,
        classes,
        optionTab,
        newUser,
        getLabel,
        onToggleModule: changeColumn,
        onToggleCheckbox: changeCheckbox,
      })}
      {renderModuleRow({
        rowModules: bottomRowModules,
        classes,
        optionTab,
        newUser,
        getLabel,
        onToggleModule: changeColumn,
        onToggleCheckbox: changeCheckbox,
      })}
      {renderModuleRow({
        rowModules: leftoverModules,
        classes,
        optionTab,
        newUser,
        getLabel,
        onToggleModule: changeColumn,
        onToggleCheckbox: changeCheckbox,
      })}
    </div>
  )
}

ManageFeatures.propTypes = {
  newUser: PropTypes.bool,
  optionTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  updateSubscriptionSettings: PropTypes.func,
  subscriptionSettings: PropTypes.arrayOf(PropTypes.object),
}

export { ManageFeatures }
export default connect(ManageFeatures)
